import * as React from "react";
import type { SVGProps } from "react";

interface Minutes20Props extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Minutes20 = ({ cancelled = false, ...props }: Minutes20Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(2.5 1)">
      <ellipse cx={9.75} cy={12.925} fill="#fff" rx={8.087} ry={8.143} />
      <path
        fill="#000"
        fillRule="nonzero"
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth={0.75}
        d="m12.302.796.002.027.007.161c0 .732-.593 1.325-1.325 1.325h-.38v.53c4.96.54 8.769 4.716 8.769 9.732 0 5.415-4.422 9.804-9.875 9.804s-9.875-4.389-9.875-9.804c0-5.016 3.81-9.192 8.77-9.732v-.53h-.38A1.325 1.325 0 0 1 6.688.984V.95c0-.732.593-1.325 1.325-1.325h2.972c.674 0 1.239.506 1.316 1.17ZM1.837 12.57c0 4.199 3.43 7.603 7.663 7.603s7.663-3.404 7.663-7.603-3.43-7.603-7.663-7.603-7.663 3.405-7.663 7.603Z"
      />
      <path
        fill="#ff1212"
        fillRule="nonzero"
        d="M4.825 17Q4 17 4 16.541q0-.599.187-1.18.188-.579.631-1.204.444-.623 1.206-1.364.375-.37.713-.74a4.4 4.4 0 0 0 .55-.732q.212-.364.224-.682.013-.6-.256-.893-.27-.293-.78-.293-.639 0-.85.625-.126.382-.3.586-.175.204-.538.204-.35 0-.55-.236t-.112-.656q.212-.944.837-1.46T6.474 8q.725 0 1.306.312.58.313.912.905.33.594.306 1.46a2.5 2.5 0 0 1-.268 1.11q-.256.496-.688.974-.43.478-.993 1.027-.537.548-.956 1.032-.42.485-.494.79H8q.825 0 .824.689 0 .7-.824.701zm7.533 0q-1.024 0-1.597-.512-.575-.511-.8-1.51-.224-.999-.224-2.472 0-1.485.225-2.484t.799-1.51Q11.334 8 12.358 8t1.586.512.792 1.51q.231.999.231 2.484 0 1.473-.23 2.472-.232.999-.793 1.51-.562.512-1.586.512m0-1.423q.425 0 .668-.268.243-.269.35-.937.106-.667.106-1.866t-.106-1.872q-.107-.675-.35-.943t-.668-.268-.674.268-.355.943-.107 1.872q0 1.2.107 1.866.105.669.355.937t.674.268"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Minutes20;
